<template>
  <div class="page-cards flex column">
    <div class="page-header header-accent card-base card-shadow--small">
			<h1>Galleries</h1>
		</div>
    <el-tabs type="border-card" class="mt-0" @tab-click="handleTabChange" v-model="activeTab">
      <el-tab-pane label="Ajouter à la gallerie" :style="height" name="upload">
        <div class="list box grow scrollable" v-loading="loading" style="height:100%">
          <ImageEditorController ref="imgEditor" :dialogVisible="imageEditorVisible" @close="closeImageEditor" :assetToEdit="assetToEdit" :types="realGalleryTypes" :preSelectedType="selectedType" @created="refreshGalleries"></ImageEditorController>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Bibliothèques" :style="height" name="library">
        <div class="mt-10">
          <el-row>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="text-left">
              <el-select v-model="selectedType" placeholder="Select" @change="changeGalleryType">
                 <el-option
                   width="200px"
                   v-for="item in types"
                   :key="item.id"
                   :label="item.name[lang]"
                   :value="item.id">
                 </el-option>
               </el-select>
             </el-col>
           </el-row>
        </div>
        <div class="list box grow scrollable pb-20" v-loading="loading" style="height:100%" >
          <masonry :cols="{default: 6, 1200: 3, 1000: 2, 480: 1}" :gutter="20" class="m-20">
            <div class="item card-base card-alt m-2" :class="{'selected' : i.selected}" v-for="(i, index) in images" :key="i.id">
            <Asset @click.native="selectImage(i.id, index)" :asset="i" class="m-10"></Asset>
              <div class="bg-info-lighter card-shadow--small p-5" style="margin-top:-5px; ">
                <el-row>
                  <el-col :xs="buttonResponsiveWitdh" :sm="buttonResponsiveWitdh" :md="buttonResponsiveWitdh" :lg="buttonResponsiveWitdh" :xl="buttonResponsiveWitdh" class="text-left">
                    <el-button  type="text" @click="handleEdition(i)" class="p-15 text-right"><i class="el-icon-edit fs-20"></i></el-button>
                  </el-col>
                  <el-col :xs="buttonResponsiveWitdh" :sm="buttonResponsiveWitdh" :md="buttonResponsiveWitdh" :lg="buttonResponsiveWitdh" :xl="buttonResponsiveWitdh" class="text-center" v-if="showInGalery">
                    <el-button  type="text" class="p-15 text-right" @click="show(index)"><i class="el-icon-search fs-20"></i></el-button>
                  </el-col>
                  <el-col :xs="buttonResponsiveWitdh" :sm="buttonResponsiveWitdh" :md="buttonResponsiveWitdh" :lg="buttonResponsiveWitdh" :xl="buttonResponsiveWitdh" class="text-right">
                    <el-button  type="text" @click="handleDelete(i.id)" class="mr-10"><i class="mdi mdi-delete fs-20"></i></el-button>
                  </el-col>
                </el-row>
              </div>
            </div>
          </masonry>
        </div>

      </el-tab-pane>
    </el-tabs>


    <img-viewer v-if="!selection" ref="viewer" :images="images"/>
  </div>
</template>
<script>

import cmsAPI from '@/services/API/cmsAPI'
import moment from 'moment-timezone'
import ImageEditorController from './image-editor-controller'
import ImgViewer from "@/components/ImgViewer";
import { EventBus } from '@/core/event-bus'
import Asset from './asset.vue'

export default {
	name: 'Gallery-controller',
  props : {
    selection : {type : Boolean, default : false},
    multiple : {type : Boolean, default : false},
    action : {type : String, default : 'library'},
    showInGalery : {type : Boolean, default: false}
  },
	data() {
		return {
      window : {
        width:0,
        height : 0,
      },
      activeTab : 'library',
      boxMargins : true,
      selectedImages : [],
			images: [],
      loading : false,
      selectedType : -1,
      assetToEdit : null,
      types : [{
        id:-1,
        name : {
          fr: 'Tout',
          en : 'All'
        }
      }],
      imageEditorVisible : false,
      viewerOptions: {
        movable: false,
        rotatable: false,
        scalable: false,
        url: 'link',
        title(image, imageData) {
          // if want to show blank title, must use alt=" "
          return image.alt
        },
      }
		}
	},
  components : {
    ImgViewer,
    ImageEditorController,
    Asset
  },
  computed : {
    realGalleryTypes(){
      return _.slice(this.types, 1);
    },
    lang(){
      return this.$i18n.locale
    },
    buttonResponsiveWitdh(){
      return !this.showInGalery ? 12 : 8;
    },
    height(){
      return "height :"+(this.window.height-360) + "px"
    }
  },
  methods : {
    handleTabChange(tab){
      if(tab.name=="upload"){
        this.unselectImages();
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    handleEdition(asset){
      this.assetToEdit = asset;
      this.openImageEditor();
    },
    handleDelete(id){
      this.$confirm("Ceci effacera l'élément. Continuer?", 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          return cmsAPI.deleteGalery(id)
            .then(()=>{
              this.fetchCMSGalleries();
              this.$message({
                type: 'success',
                message: 'Élément supprimé'
              });
            })

        }).catch((err) => {
          if(err=='cancel'){
            this.$message({
              type: 'info',
              message: 'Suppression annulée'
            });
          }else{
            this.$message({
              type: 'error',
              message: 'Une erreur est survenue. Veuillez réessayer plus tard.'
            });
          }

        });
    },
    show(index){
      // console.log("show index : ", index);
      this.$refs.viewer.show(
        this.images,
        index
      );
    },
    changeGalleryType(typeId){
      this.fetchCMSGalleries();
    },
    openImageEditor(){
      this.imageEditorVisible=true;
      this.$nextTick(() => {
        this.$refs.imgEditor.open();
      })

    },
    closeImageEditor(){
      this.imageEditorVisible = false;

    },
    unselectImages(){
      _.forEach(this.selectedImages, i=>{
        i.selected=false;
      })
      this.selectedImages.splice(0);
    },
    selectImage(id, index){
      // console.log("select image");
      if(this.selection){
        let indexFound
        if(!this.multiple){
          //Si pas de sélection multiple alors on déselectionne
          let selectedId = this.selectedImages.length>0 ? this.selectedImages[0].id : null;
          if(selectedId!=null){
            indexFound = _.findIndex(this.images, i=>{return i.id==selectedId});
            // console.log("Index found : ", indexFound);
            this.$set(this.images[indexFound], 'selected' ,false);
            this.selectedImages=[];
          }
        }
        //On regarde si l'image sélectinoné était déjèa sélectionné. Si oui alors
        //on la déselectionne.
        indexFound = _.findIndex(this.selectedImages, i=>{return i.id==id});
        this.$set(this.images[index], 'selected' ,indexFound==-1)
        if(indexFound!=-1){
          this.selectedImages.splice(indexFound,indexFound+1);
        }else{
          this.selectedImages.push(this.images[index]);
        }
        this.$emit('select', this.selectedImages)
      }
    },
    fetchCMSGalleryTypes(){
      return cmsAPI.fetchCMSGalleryTypes()
        .then(types=>{
          this.types.push(...types);
        })
    },
    refreshGalleries(){
      this.fetchCMSGalleries();
    },
    fetchCMSGalleries(){
      this.loading = true;
      let params = {};

      params.typeId = this.selectedType!=-1 ? this.selectedType : undefined;

      return cmsAPI.fetchCMSGalleries(params)
        .then(galleries=>{
          this.loading=false;
          this.images = galleries;
        }).catch(error=>{
          this.loading  = false;
          console.log(error);
        })
    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);

		},
    handleCloseDialog(){
      this.unselectImages()
    }
  },
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    EventBus.$on('close-galery-dialog',this.handleCloseDialog );
  },
  mounted(){
    return Promise.all([
      this.fetchCMSGalleryTypes(),
      this.fetchCMSGalleries()
    ])


  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';
.selected{
  opacity: 1;
  box-shadow: 0px 0px 0px 4px $text-color-accent !important
}
.page-cards {
	overflow: hidden;

	.list {
		//overflow: hidden;
		//overflow-y: auto;
		padding: 10px 20px;
		margin: 0 -20px;
		margin-top: 20px;

		.masonry {
			column-count: 4;
			column-gap: 40px;
		}

		.item {
			//padding: 20px;
			//margin: 20px 0;
			margin-bottom: 20px;
			//border-radius: 5px;
			opacity: .85;
			transition: all .25s;

			/* masonry */
			//display: inline-block;
			box-sizing: border-box;
			width: 100%;
      box-shadow: 0px 0px 0px 1px $text-color-accent;

			img {
				width: 100%;
				max-width: 100%;
        // height:200px;
			}

			&:hover {
        cursor:pointer;
				opacity: 1;
				box-shadow: 0px 0px 0px 4px $text-color-accent;
			}
		}
	}



	.card-form {
		width: 100%;
		max-width: 400px;
		margin: 0 auto;
		box-sizing: border-box;
		padding: 8px;
		overflow: hidden;

		* {
			box-sizing: border-box;
			display: block;
			width: 100%;
			border: none;
			outline: none;
			padding: 8px;
			background: transparent;
			color: $text-color;
		}

		input {
			font-weight: bold;
			font-size: 16px;
		}

		textarea {
			resize: none;
		}

		button {
			text-transform: uppercase;
			width: auto;
			margin: 0 auto;
			cursor: pointer;
			border-bottom: 1px solid transparent;
			display: inline-block;

			&:hover {
				border-color: $text-color;
			}

			&.accent-text {
				color: $text-color-accent;

				&:hover {
					border-color: $text-color-accent;
				}
			}

			&[disabled] {
				border-color: transparent !important;
				opacity: .5;
				cursor: not-allowed;
			}

		}

		&:not(.open) {
			padding: 0px;
		}
	}
}

/* Masonry on large screens */
@media (max-width: 1200px) {
	.page-cards {
		.list {
			.masonry {
				column-count: 3;
			}
		}
	}
}

/* Masonry on medium-sized screens */
@media (max-width: 1000px) {
	.page-cards {
		.list {
			.masonry {
				column-count: 2;
			}
		}
	}
}

/* Masonry on small screens */
@media (max-width: 480px) {
	.page-cards {
		.list {
			.masonry {
				column-count: 1;
			}
		}
	}
}

</style>
